<template>
  <!-- 모바일 햄버거 버튼 -->
  <button
    @click="toggleMobileMenu"
    class="mobile-menu-button md:hidden"
    aria-label="메뉴 열기"
  >
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      stroke-width="2"
    >
      <line x1="3" y1="12" x2="21" y2="12"></line>
      <line x1="3" y1="6" x2="21" y2="6"></line>
      <line x1="3" y1="18" x2="21" y2="18"></line>
    </svg>
  </button>

  <!-- 모바일 메뉴 오버레이 -->
  <div
    v-if="isMobileMenuOpen"
    class="mobile-menu-overlay"
    @click="toggleMobileMenu"
  >
    <aside
      class="mobile-sidebar"
      @click.stop
      role="navigation"
      aria-label="마이페이지 메뉴"
    >
      <div class="mobile-sidebar-header">
        <h2 class="mobile-sidebar-title">메뉴</h2>
        <button
          @click="toggleMobileMenu"
          class="mobile-sidebar-close"
          aria-label="메뉴 닫기"
        >
          <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M18 6L6 18M6 6L18 18"
              stroke="currentColor"
              stroke-width="2"
              stroke-linecap="round"
            />
          </svg>
        </button>
      </div>

      <nav class="nav-section">
        <h3 class="nav-title" id="nav-section-1">접수·결제 정보</h3>
        <ul class="nav-list" role="list">
          <li>
            <router-link
              to="/profile/confList"
              target="_blank"
              class="nav-link"
              @click="toggleMobileMenu"
            >
              <span class="nav-icon"
                ><svg
                  width="18"
                  height="18"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  stroke-width="1.8"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  aria-hidden="true"
                >
                  <path :d="NAV_ICON.conference" /></svg
              ></span>
              <span class="nav-text">
                컨퍼런스 신청내역
                <svg
                  class="external-link-icon"
                  width="14"
                  height="14"
                  viewBox="0 0 14 14"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M11 7.66667V11.6667C11 12.0203 10.8595 12.3594 10.6095 12.6095C10.3594 12.8595 10.0203 13 9.66667 13H2.33333C1.97971 13 1.64057 12.8595 1.39052 12.6095C1.14048 12.3594 1 12.0203 1 11.6667V4.33333C1 3.97971 1.14048 3.64057 1.39052 3.39052C1.64057 3.14048 1.97971 3 2.33333 3H6.33333M9 1H13M13 1V5M13 1L5.66667 8.33333"
                    stroke="currentColor"
                    stroke-width="1.5"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </svg>
              </span>
            </router-link>
          </li>
          <li>
            <router-link
              to="/mypage/list"
              class="nav-link"
              @click="toggleMobileMenu"
            >
              <span class="nav-icon"
                ><svg
                  width="18"
                  height="18"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  stroke-width="1.8"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  aria-hidden="true"
                >
                  <path :d="NAV_ICON.order" /></svg
              ></span>
              주문내역
            </router-link>
          </li>
          <li>
            <router-link
              to="/mypage/paymentList"
              class="nav-link"
              @click="toggleMobileMenu"
            >
              <span class="nav-icon"
                ><svg
                  width="18"
                  height="18"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  stroke-width="1.8"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  aria-hidden="true"
                >
                  <path :d="NAV_ICON.payment" /></svg
              ></span>
              결제내역
            </router-link>
          </li>
        </ul>
      </nav>

      <nav class="nav-section">
        <h3 class="nav-title" id="nav-section-2">내 콘텐츠</h3>
        <ul class="nav-list" role="list">
          <li>
            <router-link
              to="/mypage/contentsBox"
              class="nav-link"
              @click="toggleMobileMenu"
            >
              <span class="nav-icon"
                ><svg
                  width="18"
                  height="18"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  stroke-width="1.8"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  aria-hidden="true"
                >
                  <path :d="NAV_ICON.contents" /></svg
              ></span>
              콘텐츠 보관함
            </router-link>
          </li>
          <li>
            <router-link
              to="/mypage/downloadHistory"
              class="nav-link"
              @click="toggleMobileMenu"
            >
              <span class="nav-icon"
                ><svg
                  width="18"
                  height="18"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  stroke-width="1.8"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  aria-hidden="true"
                >
                  <path :d="NAV_ICON.download" /></svg
              ></span>
              다운로드 내역
            </router-link>
          </li>
          <li>
            <router-link
              to="/mypage/cart"
              target="_blank"
              class="nav-link"
              @click="toggleMobileMenu"
            >
              <span class="nav-icon"
                ><svg
                  width="18"
                  height="18"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  stroke-width="1.8"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  aria-hidden="true"
                >
                  <path :d="NAV_ICON.cart" /></svg
              ></span>
              <span class="nav-text">
                장바구니
                <svg
                  class="external-link-icon"
                  width="14"
                  height="14"
                  viewBox="0 0 14 14"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M11 7.66667V11.6667C11 12.0203 10.8595 12.3594 10.6095 12.6095C10.3594 12.8595 10.0203 13 9.66667 13H2.33333C1.97971 13 1.64057 12.8595 1.39052 12.6095C1.14048 12.3594 1 12.0203 1 11.6667V4.33333C1 3.97971 1.14048 3.64057 1.39052 3.39052C1.64057 3.14048 1.97971 3 2.33333 3H6.33333M9 1H13M13 1V5M13 1L5.66667 8.33333"
                    stroke="currentColor"
                    stroke-width="1.5"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </svg>
              </span>
            </router-link>
          </li>
        </ul>
      </nav>

      <nav class="nav-section">
        <h3 class="nav-title" id="nav-section-3">작성한 글 & 리뷰</h3>
        <ul class="nav-list" role="list">
          <li>
            <router-link
              to="/mypage/post"
              class="nav-link"
              @click="toggleMobileMenu"
            >
              <span class="nav-icon"
                ><svg
                  width="18"
                  height="18"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  stroke-width="1.8"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  aria-hidden="true"
                >
                  <path :d="NAV_ICON.post" /></svg
              ></span>
              내가 작성한 글
            </router-link>
          </li>
          <li>
            <router-link
              to="/mypage/review"
              class="nav-link"
              @click="toggleMobileMenu"
            >
              <span class="nav-icon"
                ><svg
                  width="18"
                  height="18"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  stroke-width="1.8"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  aria-hidden="true"
                >
                  <path :d="NAV_ICON.review" /></svg
              ></span>
              나의 리뷰
            </router-link>
          </li>
        </ul>
      </nav>
    </aside>
  </div>

  <!-- 데스크톱 사이드바 -->
  <aside class="sidebar-nav" role="navigation" aria-label="마이페이지 메뉴">
    <div class="nav-section" aria-labelledby="nav-desktop-1">
      <h3 class="nav-title" id="nav-desktop-1">접수·결제 정보</h3>
      <ul class="nav-list" role="list">
        <li>
          <router-link to="/profile/confList" target="_blank" class="nav-link">
            <span class="nav-icon"
              ><svg
                width="18"
                height="18"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                stroke-width="1.8"
                stroke-linecap="round"
                stroke-linejoin="round"
                aria-hidden="true"
              >
                <path :d="NAV_ICON.conference" /></svg
            ></span>
            <span class="nav-text">
              컨퍼런스 신청내역
              <svg
                class="external-link-icon"
                width="14"
                height="14"
                viewBox="0 0 14 14"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M11 7.66667V11.6667C11 12.0203 10.8595 12.3594 10.6095 12.6095C10.3594 12.8595 10.0203 13 9.66667 13H2.33333C1.97971 13 1.64057 12.8595 1.39052 12.6095C1.14048 12.3594 1 12.0203 1 11.6667V4.33333C1 3.97971 1.14048 3.64057 1.39052 3.39052C1.64057 3.14048 1.97971 3 2.33333 3H6.33333M9 1H13M13 1V5M13 1L5.66667 8.33333"
                  stroke="currentColor"
                  stroke-width="1.5"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>
            </span>
          </router-link>
        </li>
        <li>
          <router-link to="/mypage/list" class="nav-link">
            <span class="nav-icon"
              ><svg
                width="18"
                height="18"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                stroke-width="1.8"
                stroke-linecap="round"
                stroke-linejoin="round"
                aria-hidden="true"
              >
                <path :d="NAV_ICON.order" /></svg
            ></span>
            주문내역
          </router-link>
        </li>
        <li>
          <router-link to="/mypage/paymentList" class="nav-link">
            <span class="nav-icon"
              ><svg
                width="18"
                height="18"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                stroke-width="1.8"
                stroke-linecap="round"
                stroke-linejoin="round"
                aria-hidden="true"
              >
                <path :d="NAV_ICON.payment" /></svg
            ></span>
            결제내역
          </router-link>
        </li>
      </ul>
    </div>

    <div class="nav-section" aria-labelledby="nav-desktop-2">
      <h3 class="nav-title" id="nav-desktop-2">내 콘텐츠</h3>
      <ul class="nav-list" role="list">
        <li>
          <router-link to="/mypage/contentsBox" class="nav-link">
            <span class="nav-icon"
              ><svg
                width="18"
                height="18"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                stroke-width="1.8"
                stroke-linecap="round"
                stroke-linejoin="round"
                aria-hidden="true"
              >
                <path :d="NAV_ICON.contents" /></svg
            ></span>
            콘텐츠 보관함
          </router-link>
        </li>
        <li>
          <router-link to="/mypage/downloadHistory" class="nav-link">
            <span class="nav-icon"
              ><svg
                width="18"
                height="18"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                stroke-width="1.8"
                stroke-linecap="round"
                stroke-linejoin="round"
                aria-hidden="true"
              >
                <path :d="NAV_ICON.download" /></svg
            ></span>
            다운로드 내역
          </router-link>
        </li>
        <li>
          <router-link to="/mypage/cart" target="_blank" class="nav-link">
            <span class="nav-icon"
              ><svg
                width="18"
                height="18"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                stroke-width="1.8"
                stroke-linecap="round"
                stroke-linejoin="round"
                aria-hidden="true"
              >
                <path :d="NAV_ICON.cart" /></svg
            ></span>
            <span class="nav-text">
              장바구니
              <svg
                class="external-link-icon"
                width="14"
                height="14"
                viewBox="0 0 14 14"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M11 7.66667V11.6667C11 12.0203 10.8595 12.3594 10.6095 12.6095C10.3594 12.8595 10.0203 13 9.66667 13H2.33333C1.97971 13 1.64057 12.8595 1.39052 12.6095C1.14048 12.3594 1 12.0203 1 11.6667V4.33333C1 3.97971 1.14048 3.64057 1.39052 3.39052C1.64057 3.14048 1.97971 3 2.33333 3H6.33333M9 1H13M13 1V5M13 1L5.66667 8.33333"
                  stroke="currentColor"
                  stroke-width="1.5"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>
            </span>
          </router-link>
        </li>
      </ul>
    </div>

    <div class="nav-section" aria-labelledby="nav-desktop-3">
      <h3 class="nav-title" id="nav-desktop-3">작성한 글 & 리뷰</h3>
      <ul class="nav-list" role="list">
        <li>
          <router-link to="/mypage/post" class="nav-link">
            <span class="nav-icon"
              ><svg
                width="18"
                height="18"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                stroke-width="1.8"
                stroke-linecap="round"
                stroke-linejoin="round"
                aria-hidden="true"
              >
                <path :d="NAV_ICON.post" /></svg
            ></span>
            내가 작성한 글
          </router-link>
        </li>
        <li>
          <router-link to="/mypage/review" class="nav-link">
            <span class="nav-icon"
              ><svg
                width="18"
                height="18"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                stroke-width="1.8"
                stroke-linecap="round"
                stroke-linejoin="round"
                aria-hidden="true"
              >
                <path :d="NAV_ICON.review" /></svg
            ></span>
            나의 리뷰
          </router-link>
        </li>
      </ul>
    </div>
  </aside>
</template>

<script setup>
import { ref, onMounted, onUnmounted } from "vue";

// 메뉴 아이콘 (24x24 stroke path)
const NAV_ICON = {
  conference:
    "M16 4h2a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h2M9 2h6a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1H9a1 1 0 0 1-1-1V3a1 1 0 0 1 1-1zM9 12h6M9 16h4",
  order:
    "M6 2 3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4zM3 6h18M16 10a4 4 0 0 1-8 0",
  payment:
    "M3 4h18a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2zM1 10h22",
  contents: "M21 8v13H3V8M1 3h22v5H1zM10 12h4",
  download: "M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4M7 10l5 5 5-5M12 15V3",
  cart: "M9 22a1 1 0 1 0 0-2 1 1 0 0 0 0 2zM20 22a1 1 0 1 0 0-2 1 1 0 0 0 0 2zM1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6",
  post: "M12 20h9M16.5 3.5a2.121 2.121 0 0 1 3 3L7 19l-4 1 1-4L16.5 3.5z",
  review:
    "M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z",
};

// 모바일 메뉴 상태
const isMobileMenuOpen = ref(false);

const toggleMobileMenu = () => {
  isMobileMenuOpen.value = !isMobileMenuOpen.value;
  if (isMobileMenuOpen.value) {
    document.body.style.overflow = "hidden";
  } else {
    document.body.style.overflow = "";
  }
};

// ESC 키로 모바일 메뉴 닫기
const handleKeyDown = (event) => {
  if (event.key === "Escape" && isMobileMenuOpen.value) {
    toggleMobileMenu();
  }
};

onMounted(() => {
  document.addEventListener("keydown", handleKeyDown);
});

onUnmounted(() => {
  document.removeEventListener("keydown", handleKeyDown);
  document.body.style.overflow = "";
});
</script>

<style scoped lang="scss">
/* ========================================
   Mobile Menu Button
   ======================================== */
.mobile-menu-button {
  display: none;
  padding: 8px;
  background: transparent;
  border: none;
  color: #555961;
  cursor: pointer;
  transition: color 0.2s;

  &:hover {
    color: #0c3388;
  }

  @media (max-width: 767px) {
    display: flex;
  }
}

/* ========================================
   Mobile Menu Overlay
   ======================================== */
.mobile-menu-overlay {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.5);
  z-index: 1000;
  animation: fadeIn 0.3s ease-out;
}

.mobile-sidebar {
  position: fixed;
  left: 0;
  top: 0;
  width: 280px;
  height: 100%;
  background: #ffffff;
  z-index: 1001;
  overflow-y: auto;
  animation: slideInLeft 0.3s ease-out;
  box-shadow: 4px 0 12px rgba(0, 0, 0, 0.1);
}

.mobile-sidebar-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 24px;
  border-bottom: 1px solid #dee0e3;
}

.mobile-sidebar-title {
  font-size: 20px;
  font-weight: 700;
  color: #222;
  margin: 0;
}

.mobile-sidebar-close {
  padding: 8px;
  background: transparent;
  border: none;
  color: #555961;
  cursor: pointer;
  transition: color 0.2s;

  &:hover {
    color: #0c3388;
  }
}

/* ========================================
   Sidebar Navigation
   ======================================== */
.sidebar-nav {
  position: sticky;
  top: 80px;
  height: fit-content;
  background: #ffffff;
  border: 1px solid #dee0e3;
  border-radius: 16px;
  padding: 20px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);

  @media (max-width: 767px) {
    display: none;
  }
}

.nav-section {
  & + .nav-section {
    margin-top: 32px;
    padding-top: 32px;
    border-top: 1px solid #f0f0f0;
  }
}

.nav-title {
  font-size: 14px;
  font-weight: 700;
  color: #222;
  margin: 0 0 16px 0;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.nav-list {
  list-style: none;
  padding: 0;
  margin: 0;
  display: flex;
  flex-direction: column;
  gap: 0;
}

.nav-link {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 12px 16px;
  border-radius: 8px;
  color: #555961;
  font-size: 1rem;
  font-weight: 500;
  text-decoration: none;
  transition: all 0.2s;
  white-space: nowrap;

  .nav-icon {
    display: inline-flex;
    flex-shrink: 0;
    width: 18px;
    height: 18px;
  }

  .nav-text {
    display: flex;
    align-items: center;
    gap: 6px;
  }

  .external-link-icon {
    flex-shrink: 0;
    opacity: 0.7;
    transition: opacity 0.2s;
  }

  &:hover {
    background: #f5f7fa;
    color: #0c3388;

    .external-link-icon {
      opacity: 1;
    }
  }

  &.router-link-active {
    background: #e8eef8;
    color: #0c3388;
    font-weight: 600;

    .external-link-icon {
      opacity: 1;
    }
  }
}

/* ========================================
   Animations
   ======================================== */
@keyframes fadeIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

@keyframes slideInLeft {
  from {
    transform: translateX(-100%);
  }
  to {
    transform: translateX(0);
  }
}

/* ========================================
   Focus Styles
   ======================================== */
*:focus-visible {
  outline: 2px solid #0c3388;
  outline-offset: 2px;
}
</style>
